/* raw layout hash: _guest-checkout-session-layout:f3ec94989a914a19acb72d8d68180ff952275fd351b2704f895c64c56410e082 */
import React from 'react';
import AppShell from './AppShell.jsx';

// Raw layout: _guest-checkout-session-layout.html — top navbar + mobile bottom bar. Menu entries are role-based (see AppShell / menuData.js).

export default function GuestCheckoutSessionLayout() {
  return <AppShell />;
}
